module.exports = __webpack_public_path__ + "assets/img/case1_app.3aaee849.png";